import { render, staticRenderFns } from "./push-list-item.vue?vue&type=template&id=461505b8&scoped=true&"
import script from "./push-list-item.vue?vue&type=script&lang=js&"
export * from "./push-list-item.vue?vue&type=script&lang=js&"
import style0 from "./push-list-item.vue?vue&type=style&index=0&id=461505b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461505b8",
  null
  
)

export default component.exports